"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retryPromise = exports.retryFetch = exports.getTermsMessage = exports.getDefaultTermsMessage = exports.default = void 0;

var _immutable = require("immutable");

var _react = _interopRequireWildcard(require("react"));

var _subdomain = require("./subdomain");

var _excluded = ["dispatch", "types", "promise"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AFC_TYPE_BENEFITS = ['1976', '219', '403', '1337', '5001', '5015', // AFC_BENEFITS
'1413', //  business-platinum airline-bonus displays airline-fee-credit status
'2356' // business-gold 25% Airline Bonus airline-fee-credit status
];

var nameCleaner = function nameCleaner(str) {
  if (typeof str !== 'string' || !str) {
    return 'Missing Tile Name';
  }

  return str.split('-').map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join('');
};

var resReducer = function resReducer(res) {
  return res.data;
};

var createAction = function createAction(_ref) {
  var dispatch = _ref.dispatch,
      types = _ref.types,
      promise = _ref.promise,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _types = _slicedToArray(types, 3),
      REQUEST = _types[0],
      SUCCESS = _types[1],
      FAILURE = _types[2];

  if (!promise) {
    return dispatch({
      type: FAILURE,
      error: 'No promise supplied'
    });
  }

  dispatch(_objectSpread({
    type: REQUEST
  }, rest));
  return promise.then(resReducer).then(function (result) {
    return dispatch(_objectSpread({
      type: SUCCESS,
      payload: result
    }, rest));
  }, function (error) {
    return dispatch(_objectSpread({
      type: FAILURE,
      error: error
    }, rest));
  });
};

var isUrlExternal = function isUrlExternal(url) {
  var rejectDomains = ['www.Delta.com', 'www.prioritypass.com', 'www.globalentry.gov', 'www.tsa.gov', 'promotions.gogoair.com', 'amex.boingo.com', 'wifi.boingo.com', 'www.departures.com', 'www.boingo.com', 'www.gogoair.com', 'www.delta.com', 'JetBlue.com', 'www.jetblue.com', 'SPG.com', 'www.mbusa.com', 'www.morganstanley.com', 'www.morganstanleyclientserv.com', 'www.HHonors.com', 'hhonors.com', 'sheratonclubroom.com', 'expedia.com', 'hotwire.com', 'priceline.com', 'orbitz.com', 'booking.com', 'Travelocity.com', 'ctrip.com', 'elong.com', 'www.spg.com', 'www.starwoodhotels.com', 'delta.com', 'lowes.com', 'Lowes.com', 'www.lowesforpros.com', 'LowesForPros.com', 'nationalcar.com', 'link.hertz.com', 'avis.com'];

  for (var i = 0; i < rejectDomains.length; i += 1) {
    if (url.indexOf(rejectDomains[i]) > -1) {
      return true;
    }
  }

  return false;
};

var longCtaChecker = function longCtaChecker(ctaText, altText) {
  if (altText && altText.length >= '30') {
    return 'btn-small-label';
  } else if (ctaText && ctaText.length >= '30') {
    return 'btn-small-label';
  }

  return '';
};

var checkRenewPeriod = function checkRenewPeriod(enrollDate) {
  var currentDate = new Date();

  if (currentDate.getMonth() === 0) {
    var enrollYear = enrollDate.split('-')[0];
    var currentYear = currentDate.getFullYear();

    if (enrollYear < currentYear) {
      return true;
    }
  }

  return false;
};

var isAFC = function isAFC(id) {
  var AFC_BENEFITS = ['1976', '219', '403', '1337', '5001', '5015'];
  return AFC_BENEFITS.includes(id);
}; // Used for business-platinum, airline-bonus displays airline-fee-credit status


var isAirlineBonus = function isAirlineBonus(id) {
  return id === '1413';
}; // consolidated function for all AFC=true benefits


var isAFCTypeBenefit = function isAFCTypeBenefit(id) {
  return AFC_TYPE_BENEFITS.includes(id);
};

var getEnv = function getEnv(state) {
  return (0, _immutable.fromJS)(state).getIn(['config', 'localeFilename']);
};

var getProperLocale = function getProperLocale(state) {
  return (0, _immutable.fromJS)(state).getIn(['intl', 'activeLocale']).toLowerCase().replace('-', '_');
};
/*  eslint-disable */


var MobileRender = function MobileRender(WrappedComponent, mobileThreshold) {
  return /*#__PURE__*/function (_Component) {
    _inherits(_class, _Component);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.state = {
        mobileView: window.innerWidth <= mobileThreshold ? true : false
      };
      _this.handleWindowWidth = _this.handleWindowWidth.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        window.addEventListener('resize', this.handleWindowWidth);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.handleWindowWidth);
      }
    }, {
      key: "handleWindowWidth",
      value: function handleWindowWidth() {
        if (window.innerWidth <= mobileThreshold) {
          this.setState({
            mobileView: true
          });
        } else {
          this.setState({
            mobileView: false
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        /*  eslint-disable */
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({
          mobileView: this.state.mobileView
        }, this.props));
      }
    }]);

    return _class;
  }(_react.Component);
};

var getTermsMessage = function getTermsMessage(data) {
  return data && data.terms ? 'Benefit Terms' : 'Amex Assurance Disclosures';
};

exports.getTermsMessage = getTermsMessage;

var getDefaultTermsMessage = function getDefaultTermsMessage(data) {
  return data && data.terms ? '&Dagger;Benefit Terms' : '&diams;Amex Assurance Disclosures';
};

exports.getDefaultTermsMessage = getDefaultTermsMessage;

var retryPromise = function retryPromise() {
  var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;

  // eslint-disable-next-line no-unused-vars
  var delayPromise = function delayPromise(delay) {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        resolve();
      }, delay);
    });
  };

  var count = 0;
  return function retry(operation, delay) {
    return operation().catch(function () {
      return (// eslint-disable-next-line
        delayPromise(delay).then(function () {
          // eslint-disable-next-line no-plusplus
          count++;

          if (count <= max) {
            return retry(operation, delay * 2);
          }
        })
      );
    });
  };
};

exports.retryPromise = retryPromise;

var retryFetch = function retryFetch(fetchFn, delay) {
  var retryPromiseOnce = retryPromise(1);

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var bindedFetch = fetchFn.bind.apply(fetchFn, [null].concat(args));
  return retryPromiseOnce(bindedFetch, delay);
};

exports.retryFetch = retryFetch;
var _default = {
  nameCleaner: nameCleaner,
  resReducer: resReducer,
  createAction: createAction,
  isUrlExternal: isUrlExternal,
  longCtaChecker: longCtaChecker,
  checkRenewPeriod: checkRenewPeriod,
  isAFC: isAFC,
  isAirlineBonus: isAirlineBonus,
  isAFCTypeBenefit: isAFCTypeBenefit,
  MobileRender: MobileRender,
  getEnv: getEnv,
  getProperLocale: getProperLocale,
  getTermsMessage: getTermsMessage,
  getDefaultTermsMessage: getDefaultTermsMessage,
  retryPromise: retryPromise,
  retryFetch: retryFetch,
  getSubdomain: _subdomain.getSubdomain
};
exports.default = _default;